import React from "react";
import { Link } from 'react-router-dom'
import image from '../../assets/images/Leadership/anshika-pandey-2.jpg'
const HRexe = () => {
    return (

        <div className="container py-lg-5 py-md-4 py-3">
            <div className="row">
                <div className="col-lg-6 col-md-6 d-flex align-items-center">
                    <img className='img-fluid' src={image} alt="Anshika Pandey" />
                </div>
                <div className="col-lg-6 col-md-6 ">
                    <div className="ceo">
                        <h6>Corporate Service Team</h6>
                        <h1 className='fw-bold mb-3'>Anshika Pandey</h1>
                        <h4>Human Resource Executive | TechTorch Solutions</h4>
                        <div className='social-media'>
                            <Link to="https://www.linkedin.com/in/anshika-pandey-42631832a/"><i className="bi bi-linkedin"></i></Link>
                        </div>
                        <p>
                            At TechTorch Solutions, Anshika Pandey brings a proactive and people-focused approach to supporting the company’s human resources initiatives. With a strong dedication to fostering a positive workplace culture, she assists in implementing HR policies, organizing employee programs, and ensuring smooth day-to-day operations within the HR department.

                            Known for her approachable demeanor and keen attention to employee needs, Anshika Pandey helps promote engagement, collaboration, and a sense of community among staff.
                        </p>
                        <p>
                            By supporting both management and employees, she plays a vital role in making sure every team member feels valued, heard, and empowered to succeed in their professional journey.

                            With a belief that work-life balance is essential, Anshika Pandey ensures that employees have the resources and support they need to thrive both personally and professionally. </p>

                    </div>
                </div>
            </div>
        </div>
    )

}

export default HRexe;